import reduce from 'lodash/fp/reduce'


const fields = {
    PASSCODE: 'passCode'
}

export const initialValues = reduce((acc, field) => ({
    ...acc,
    passCode: ''
}), {}, Object.values(fields))

export default fields
